import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { IoReorderFourOutline, IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import classes from "./Header.module.css";
import { companyName } from "../../util/config";
import Nav from "./Nav";
import TradingViewTicker from "../trading-views/TradingViewTicker";

const Header = () => {
  const [open, setOpen] = useState(false);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const location = useLocation();
  const navRef = useRef(null);

  const openNav = () => {
    setOpen(true);
    navRef.current.classList.add(classes.open);
  };

  const closeNav = () => {
    setOpen(false);
    navRef.current.classList.remove(classes.open);
  };

  return (
    <header className={classes.container}>
      <div className={classes.header}>
        <Link to="/" className={classes.logo}>
          <h2>{companyName}</h2>
        </Link>
        <div ref={navRef} className={classes.nav}>
          <Nav />
        </div>
        {!open && (
          <IoReorderFourOutline className={classes.icon} onClick={openNav} />
        )}
        {open && <IoClose className={classes.icon} onClick={closeNav} />}
      </div>
      <TradingViewTicker />
      {(location.pathname === "/" || location.pathname === "/plans") &&
        !isLoggedIn && (
          <div className={classes.bonusBanner}>
            🔥HOT DEAL: Claim <span className={classes.bonus}>$1000</span> bonus
            on{" "}
            <Link className={classes.signup} to="/create-account">
              sign up
            </Link>
            🔥
          </div>
        )}
    </header>
  );
};

export default Header;
